import * as React from 'react';
import BackToTopButton from './BackToTopButton';

function ExecutiveSubscriptionSuccess() {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">Welcome to Executive!</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Subscription Confirmed</li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <div className="text-center mb-4">
                <h2 className="text-info">🎉 Welcome to the Executive Plan! 🎉</h2>
                <p className="lead">You now have access to our most comprehensive features and unlimited AI assistance.</p>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <h4 className="text-info mb-3">Unlimited AI Assistant Access</h4>
                  <ul className="plan-features">
                    <li><strong>Unlimited AI Assistants Access:</strong></li>
                    <ul>
                      <li><strong>Unlimited</strong> questions/tasks to <strong>Lima</strong>, our AI Stock Market Research Analyst</li>
                      <li><strong>Unlimited</strong> earnings call questions to <strong>Saturday</strong>, our AI Stock Market Research Assistant</li>
                      <li><strong>Unlimited</strong> questions/tasks on 10-K, 10-Q, and 8-K filing documents to <strong>June</strong>, our advanced and sophisticated AI Stock Market Research Assistant</li>
                    </ul>
                    <li><strong>Enhanced AI Features:</strong></li>
                    <ul>
                      <li>100 autonomous AI generated insights per month</li>
                    </ul>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h4 className="text-info mb-3">Premium Features Included</h4>
                  <ul className="plan-features">
                    <li>Save valuations for companies using your own assumptions</li>
                    <li>Discover when your favorite stocks are undervalued using your own saved assumptions</li>
                    <li>Add stocks you love to your favorites list</li>
                    <li>Track the performance and valuations of the stocks you love</li>
                    <li>Unlimited company look-ups</li>
                    <li>Create unlimited watchlists</li>
                    <li>Create unlimited stock screens</li>
                    <li>Discover new companies and investment opportunities with your pre-set screeners and assumptions</li>
                    <li>All FREE plan features included</li>
                  </ul>
                </div>
              </div>

              <div className="text-center mt-4">
                <a href="/dashboard" className="btn btn-info mr-2">Go to Dashboard</a>
                <a href="/" className="btn btn-outline-info">Get started!</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackToTopButton />
    </div>
  );
}

export default ExecutiveSubscriptionSuccess;
